export default __webpack_public_path__ + "static/media/HDTX_Pengumuman RUPS 2022.611db11f.pdf";